import chroma from 'chroma-js';
import { Body01 } from 'Components/designSystem';
import Body03 from 'Components/designSystem/components/typography/Body03';
import React from 'react';
import styled from 'styled-components';

interface OfferAdditionalActionProps {
    description: string;
    text: string;
    icon: React.ReactNode;
    iconColor?: string;
    onClick?: () => void;
}

export default function OfferAdditionalAction(props: OfferAdditionalActionProps) {
    const { text, icon, iconColor, onClick, description } = props;

    return (
        <Root onClick={ onClick }
            detailed
        >
            <IconWrapper color={ iconColor }>{ icon }</IconWrapper>
            <div>
                <DetailedTitle>{ text }</DetailedTitle>
                <Description>{ description }</Description>
            </div>
        </Root>
    );
}

const DetailedTitle = styled(Body01)`
    font-weight: ${ ({ theme }) => theme.fontWeightMedium };
`;

const Description = styled(Body03)`
    color: ${ ({ theme }) => theme.semanticColor.textSecondary };
`;

const Root = styled.div<{ detailed?: boolean }>`
    padding: 12px;
    display: flex;
    border: 1px solid ${ ({ theme }) => theme.borderColor };
    border-radius: ${ ({ theme }) => theme.borderRadius };
    flex-direction: column;
    gap: 8px;
    flex: 1;
    cursor: pointer;

    :hover {
        border-color: ${ ({ theme }) => theme.semanticColor.primary };
    }

    ${ ({ detailed }) => detailed && `
        flex-direction: row;
        gap: 12px;
    ` }
`;

const IconWrapper = styled.div`
    width: 32px;
    height: 32px;
    padding: 6px;
    border-radius: 50%;

    ${ ({ color }) => color && `background-color: ${ chroma(color).alpha(0.08).css() };` }

    svg {
        width: 20px;
        height: 20px;
        margin-right: 12px;
        stroke-width: 0;
        path {
            fill: ${ ({ color }) => color };
        }
    }
`;
